import { graphql } from 'gatsby';
import * as React from 'react';
import { RelatedArticles } from '../../components';
import { ContentfulPost } from '../../interfaces';
import { PageFragmentWrap } from './page-fragment-wrap';

interface RecentBlogpostsProperties {
  location: any;
  data: {
    blogposts: {
      edges: {
        node: ContentfulPost;
      }[];
    };
    site;
  };
}

const RecentBlogposts = ({ location, data: { blogposts } }: RecentBlogpostsProperties) => (
  <PageFragmentWrap>
    <RelatedArticles blogposts={blogposts.edges.map(x => x.node)} entityType={location} />
  </PageFragmentWrap>
);

export default RecentBlogposts;

export const recentBlogpostQuery = graphql`
  query recentBlogPostQuery {
    blogposts: allContentfulBlogPost(
      filter: {slug: {ne: null}, fields: {locale: {eq: "en-US"}}}
      sort: {time: DESC}
      limit: 3
    ) {
      edges {
        node {
          ...blogpostBaseFields
        }
      }
    }
  }
`;
